import React from 'react'
import { IconShield } from '../../../shared/icon/icon'
import { ButtonPrimary, ButtonSecondary } from '../../../shared/component/button'

export const ExpiredView = ({ onClose, onRetry }) => (
  <div className="ld-expired">
    <div className="ld-expired__icon"><IconShield /></div>
    <div className="ld-expired__title">Code expired</div>
    <div className="ld-expired__subtitle">This code expired before it was approved.</div>
    <div className="ld-actions">
      <ButtonSecondary text="Close" onClick={onClose} />
      <ButtonPrimary text="Enter New Code" onClick={onRetry} />
    </div>
  </div>
)
